export enum DaAssistantActionType {
  LOCATE_EXPENSES = 'LOCATE_EXPENSES',
  RUN_AI_CHECK = 'RUN_AI_CHECK',
  PARAMETER_FIX = 'PARAMETER_FIX',
  RAISE_WITH_AGENT = 'RAISE_WITH_AGENT',
  CA_ITEM_FLAG_ADVISORY = 'CA_ITEM_FLAG_ADVISORY',
  APPROVE_EXPENSES = 'APPROVE_EXPENSES',
  OPERATIONS_SUMMARY = 'OPERATIONS_SUMMARY',
  CA_ALLOCATE = 'CA_ALLOCATE',
  REVERT_PARAMETER_FIX = 'REVERT_PARAMETER_FIX',
  REVERT_APPROVE_EXPENSES = 'REVERT_APPROVE_EXPENSES',
  REVERT_CA_ALLOCATE = 'REVERT_CA_ALLOCATE'
}

export const DA_ASSISTANT_ACTION_TYPES = Object.values(DaAssistantActionType);

export function isDaAssistantActionType(
  value: unknown
): value is DaAssistantActionType {
  return (
    typeof value === 'string' &&
    (DA_ASSISTANT_ACTION_TYPES as readonly string[]).includes(value)
  );
}
